import type { PDFRasterizeFunction } from "@pdfking/renderer-api"

export const PDFRasterize: PDFRasterizeFunction = async function* () {
  throw new Error("PDFRasterize not implemented in pdflib")
}
